import React from "react";

import "./SelectedFiltersCounter.scss";

export default function SelectedFiltersCounter({ amount }) {
  return amount > 0 ? (
    <div className="selected-filters-counter text-body-medium">{amount}</div>
  ) : null;
}
